import Big from 'big.js';
import _ from 'lodash';

import * as graphql from 'generated/graphql';
import { currencyAndDecimalFieldPolicy } from 'modules/common/layer01/apolloClient/cache/typePolicies/fieldPolicies';
import { ITypeSpecificPolicy } from './shared';



export const AccountDataPoint: ITypeSpecificPolicy<graphql.AccountDataPoint> = {

  fields: {
    value: currencyAndDecimalFieldPolicy(),



    formattedValue: {
      read: (existing, { readField }) => {
        const valueFieldValue = readField<Big>('value');
        const unitFieldValue = readField<graphql.DataPointUnit>('unit');
        if (_.isNil(valueFieldValue) || _.isNil(unitFieldValue)) {
          return existing;
        }

        if (unitFieldValue === 'percentage') {
          return valueFieldValue.mul(100).toFixed(2) + '%';
        }

        const abs = valueFieldValue.abs();
        const value = __divideNumber(abs);
        const suffix = __getMagnitude(abs);

        // TODO In case we want to modify this.
        return value.toFixed(2) + suffix;
      }
    },



    formattedValueForFinance: {
      read: (existing, { readField }) => {
        const valueFieldValue = readField<Big>('value');
        const unitFieldValue = readField<graphql.DataPointUnit>('unit');
        if (_.isNil(valueFieldValue) || _.isNil(unitFieldValue)) {
          return existing;
        }
        if (unitFieldValue === 'percentage') {
          return valueFieldValue.mul(100).toFixed(1);
        }

        if (unitFieldValue === 'days') {
          return valueFieldValue.toFixed(0);
        }

        const abs = valueFieldValue.abs();
        const value = __divideNumber(abs);

        if (unitFieldValue === 'usdpershare') {
          return value.toFixed(2);
        }
        return value.toFixed(1);
      }
    }
  }
};



function __divideNumber(value: Big) {
  const abs = value.abs();
  if (abs.gte(1_000_000_000_000)) {
    return value.div(1_000_000_000_000);
  } else if (abs.gte(1_000_000_000)) {
    return value.div(1_000_000_000);
  } else if (abs.gte(1_000_000)) {
    return value.div(1_000_000);
  }

  return value;
}



function __getMagnitude(value: Big) {
  const abs = value.abs();
  if (abs.gte(1_000_000_000_000)) {
    return 'T';
  } else if (abs.gte(1_000_000_000)) {
    return 'B';
  } else if (abs.gte(1_000_000)) {
    return 'M';
  }

  return '';
}
